import { createBrowserRouter, Navigate } from "react-router-dom";
import authRoutes from "./features/auth/routes/auth.routes";
import phoneVerificationRoutes from "./features/auth/routes/phoneVerification.routes";
import adminRoutes from "./features/admin/routes/admin.routes";
import planRoutes from "./features/plan/routes/plan.routes";
import kycRoutes from "./features/kyc/routes/kyc.routes";
import ReferralHandler from "./features/auth/components/ReferralHandler";
import paymentRoutes from "./features/payments/routes/payment.routes";

const routes = createBrowserRouter([
  {
    path: "r/:referralCode",
    element: <ReferralHandler />,
  },
  {
    path: "membership/select",
    element: <Navigate to="/plan/membership" replace />,
  },
  adminRoutes,
  authRoutes,
  phoneVerificationRoutes,
  ...kycRoutes,
  paymentRoutes,
  planRoutes,
]);

export default routes;
